import { ccv2Fetch } from './index';

/** @param {boolean} includeInactive @returns {Promise<Array>} */
export const fetchPauseReasons = (includeInactive = false) =>
  ccv2Fetch(`/v2/callcenter/pause-reasons${includeInactive ? '?includeInactive=true' : ''}`);

/** @param {number} id @returns {Promise<Object>} */
export const fetchPauseReason = (id) =>
  ccv2Fetch(`/v2/callcenter/pause-reasons/${id}`);

/**
 * @param {{ name: string, isGlobal?: boolean, isActive?: boolean, color?: string }} dto
 * @returns {Promise<Object>}
 */
export const createPauseReason = (dto) =>
  ccv2Fetch('/v2/callcenter/pause-reasons', { method: 'POST', body: JSON.stringify(dto) });

/** @param {number} id @param {Object} dto @returns {Promise<Object>} */
export const updatePauseReason = (id, dto) =>
  ccv2Fetch(`/v2/callcenter/pause-reasons/${id}`, { method: 'PATCH', body: JSON.stringify(dto) });

/** @param {number} id @returns {Promise<null>} */
export const deletePauseReason = (id) =>
  ccv2Fetch(`/v2/callcenter/pause-reasons/${id}`, { method: 'DELETE' });
